export const maqueta = {
    text1: "تم إجراء",
    text2: "عمليات تسجيل وصول",
    text3: "ورقة موفَّرة 😊",
    text4: "مع كل 100 عملية تسجيل وصول نزرع شجرة مع",
    text5: "ONE TREE PLANTED",
    text6: "الإشعارات",
    text7: "لا توجد إشعارات",
    text8: "عرض الكل",
    text9: "مرحبًا بك",
    text10: "الشركة",
    text11: "كل وحدات الإقامة",
    text12: "الملف الشخصي",
    text13: "تسجيل الخروج",
    text14: "عذرًا، حدث خطأ أثناء تسجيل الخروج",
    text15: "رُفض دفع اشتراكك",
    text16: "لمتابعة استخدام WACheckin عليك إتمام الدفع",
    text17: "معلومات تسجيل الوصول",
    text18: "بيانات تسجيل الوصول",
    text19: "تاريخ الطلب:",
    text20: " الساعة",
    text21: "البيانات المجمّعة أثناء تسجيل وصول النزيل",
    text22: "الاسم الأول",
    text23: "اسم العائلة",
    text24: "الهاتف",
    text25: "تاريخ الإقامة",
    text26: "نوع الوثيقة",
    text27: "جواز السفر",
    text28: "بطاقة الهوية الوطنية",
    text29: "رقم الوثيقة",
    text30: "معلومات إضافية",
    text31: "انتهاء صلاحية الوثيقة",
    text32: "الجنسية",
    text33: "تاريخ الميلاد",
    text34: "الجنس",
    text35: "أنثى",
    text36: "ذكر",
    text37: "إغلاق",
    text38: "تسجيلات الوصول",
    text39: "طلبات الخدمات",
    text40: "وحدات الإقامة",
    text41: "البيع المتقاطع",
    text42: "التكاملات",
    text43: "الفوترة",

    // Corrections 
    p1: "الحجوزات",

    // Plan validation corrections
    p2: "طوّر خطتك لإجراء تسجيلات الوصول",
    p3: "عذرًا، لا يوجد لديك حاليًا اشتراك نشط أو أرصدة لوحدة إقامتك.",
    p4: "ترقية الخطة",

    p5: "تسجيلات الوصول غير متاحة في وحدة الإقامة هذه.",
    p6: "لمزيد من المعلومات، يرجى التواصل مع مالك وحدة الإقامة.",

    p7: "الحساب غير موثّق",
    p8: "يرجى مراجعة بريدك الوارد وتأكيد حسابك. لم يصلك البريد؟",
    p9: "إعادة الإرسال",
    p10: "جارٍ إرسال البريد، يرجى الانتظار...",
    p11: "اشتراكي",

    p12: `اللغة والمنطقة`,
    p13: `اختر لغة ومنطقة`,
    p14: "هنا يمكنك رؤية جميع تسجيلات الوصول المكتملة.",
    p15: "جدوِل تسجيلات الوصول مسبقًا وأرسلها إلى نزلائك.",
    p16: "هنا تجد طلبات الخدمات من نزلائك، مثل التأجير والجولات وغيرها.",
    p17: "رسائل WhatsApp الجماعية",
    p18: "اربط حساب WhatsApp Business بمنصّتنا وفعّل الإرسال الجماعي لرسائل مخصّصة إلى نزلائك بسرعة وسهولة، مباشرةً من رقمك الرسمي.",
    p19: "لا تزال هذه الميزة قيد التطوير.",
    p20: "",
    p21: "معلومات تسجيل الوصول",
    p22: "عمليات تسجيل الوصول المرتبطة",
    p23: "لا توجد عمليات تسجيل وصول مرتبطة.",
    p24: "مزيد من المعلومات:",
    p25: "أي وحدة إقامة تريد إدارتها؟",
    p26: "",
    p27: "",
    p28: "",
    p29: "",
    p30: "",
    p31: "",
};
